import { AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

export const PractitionerFaq = () => (
<AccordionItem value="item-2" className="bg-gradient-to-br from-gray-900 to-gray-950 border-2 border-red-900/40 rounded-xl px-6">
                <AccordionTrigger data-testid="faq-question-2" className="text-white hover:text-red-500 text-lg font-semibold">
                  Maître Diamma est-il un vrai sorcier vaudou ? Quels sont ses pouvoirs ?
                </AccordionTrigger>
                <AccordionContent className="text-gray-300 leading-relaxed">
                  Oui, <strong className="text-white">Maître Diamma</strong> est un authentique <strong className="text-red-400">sorcier vaudou</strong> 
                  héritier d'une longue lignée de grands maîtres africains. Initié dès son plus jeune âge aux mystères du vaudou béninois et haïtien, 
                  il possède plus de 20 ans d'expérience dans la pratique des rituels vaudou traditionnels. Ses pouvoirs de sorcier vaudou incluent : 
                  la maîtrise parfaite des rituels de retour affectif, des travaux de magie blanche/rouge/noire, du désenvoutement, de la voyance, 
                  de la communication avec les esprits et ancêtres, de la guérison spirituelle. 280 clients satisfaits témoignent de 
                  l'efficacité réelle de ses pouvoirs de <strong className="text-red-400">sorcier vaudou</strong>.
                </AccordionContent>
              </AccordionItem>
);
